export default __webpack_public_path__ + "static/media/kinghost.55b1ee96.svg";